import MagicJar from "../../../core/assets/oot/gshd/magic_32x32.png";
import Item from "../../../core/items/Item";
import { ItemLightDto } from "../../../core/items/ItemDataTypes";
import StaticItem from "../../../core/items/StaticItem";
import UpgradeItem from "../../../core/items/UpgradeItem";
import OotItem, { DbItemProps } from "./OotItem";
import { SimpleItemProps } from "./SimpleItemProps";

let id = "OoT_Magic"

const MagicItem = () => {


    return <OotItem id={id}>
        {({ updateOotItem, item }) => {
            return <UpgradeItem id={id} image={[MagicJar]} title={["Magic Jar"]} upgradeLabel={["", ""]} updateItem={updateOotItem} item={item} isMajor />
        }}</OotItem>

}

export default MagicItem;

export const SimpleMagicItem  = (props: SimpleItemProps) => {


    return <StaticItem
        image={MagicJar}
        onClick={props.onClick}
        name={id}
    />



}

export const DbMagicItem = (props: DbItemProps) => {

    let item = props.items?.filter(x => x.id === id)?.[0] ?? DefaultMagicItem;

    return <Item
        item={item}
        updateItem={props.update}
        image={MagicJar}
        id={id}
        title={id}
        isObtained={item.isObtained}
    />


}

const DefaultMagicItem : ItemLightDto = {
    img: MagicJar,
    id: id,
    title: id,
    childItem: undefined,
    childItemName: undefined,
    isObtained: false,
    isChecked: false,
    state: 0
}